import parse from 'html-react-parser';
import { getResourceTo } from 'react/utils/utils';

export const economyTruckPeriodList = [
  {
    id: 'GreenmileEconomyTruckDay',
    resource: 'RouteMonitor.footer.text.daily',
    period: 'DAY'
  },
  {
    id: 'GreenmileEconomyTruckWeek',
    resource: 'RouteMonitor.footer.text.weekly',
    period: 'WEEK'
  },
  {
    id: 'GreenmileEconomyTruckMonth',
    resource: 'RouteMonitor.footer.text.monthly',
    period: 'MONTH'
  },
  {
    id: 'GreenmileEconomyTruckYear',
    resource: 'RouteMonitor.footer.text.yearly',
    period: 'YEAR'
  }
];

export const economyTruckList = [
  { 
    name: 'serviceTimeCompliance',
    title: 'greenmile.minidashboard.servicetimecompliance',
    className: "service-time-compliance"
  },
  {
    name: 'mileageCompliance',
    title: 'greenmile.minidashboard.mileagecompliance',
    className: "mileage-compliance"
  },
  {
    name: 'costPerformance',
    title: 'greenmile.minidashboard.costperformance',
    className: "cost-performance"
  },
  {
    name: 'smartGeocodeCorrections',
    title: 'greenmile.minidashboard.smartgeocodingcorrections',
    className: "smart-geocoder"
  },
  {
    name: 'timeWindowCompliance',
    title: 'greenmile.minidashboard.thewindowcompliance',
    className: "time-window-compliance"
  },
  {
    name: 'stopServiceCompliance',
    title: 'greenmile.minidashboard.stopservicecompliance',
    className: "stop-service-compliance"
  }
];

function getParsedValue(actual, planned) {
  let resource = 'greenmile.minidashboard.overplan';

  let span = '';

  if (planned > actual) {
    resource = 'greenmile.minidashboard.betterthatplan';
  }

  if (actual > 0 && planned > 0) {
    const value = (1 - (actual / planned)) * 100;
    span = '<span>' + Math.round(Math.abs(value)) + '%</span> ';
  } else {
    resource = 'greenmile.minidashboard.notavailable';
  }

  const content = span + getResourceTo(resource);

  return parse(content);
}

function getSmartGeocodingValue(data) {
  const resource = "greenmile.minidashboard.smartgeocoding";
  const content = `<span>${data.totalGeocode}</span> ${getResourceTo(resource)}`;

  return parse(content);
}

function getTimeWindowComplianceValue(data) {
  let resource = "greenmile.minidashboard.notavailable";
  let span = "";

  if (data.correctTimeWindows > 0 && data.totalStops > 0) {
    resource = "";
    const value = (data.correctTimeWindows * 100) / data.totalStops;
    span = "<span>" + Math.round(Math.abs(value)) + "%</span> ";
  }

  const content = span + getResourceTo(resource);

  return parse(content);
}

function getStopServiceComplianceItem({ actual, planned, resource }) {
  let value = 0;

  if (actual > 0 && planned > 0) {
    value = Math.round(Math.abs((actual * 100) / planned));
  }

  const span = `<span>${value}% </span> `;

  return `${span}${getResourceTo(resource)} `;
}

function getStopServiceComplianceValue(data) {
  const pedingStops = data.totalStops - 
    (data.canceledStops + data.undeliveredStops + data.redeliveredStops + data.deliveredStops);
  const totalStops = data.totalStops - data.redeliveredStops;

  let content = '';
  content += getStopServiceComplianceItem({
    actual: data.deliveredStops, 
    planned: totalStops, 
    resource: "greenmile.minidashboard.serviced" 
  });
  content += getStopServiceComplianceItem({
    actual: pedingStops, 
    planned: totalStops, 
    resource: "greenmile.minidashboard.pending" 
  });
  content += getStopServiceComplianceItem({
    actual: data.canceledStops, 
    planned: totalStops, 
    resource: "greenmile.minidashboard.cancelled" 
  });
  content += getStopServiceComplianceItem({
    actual: data.undeliveredStops, 
    planned: totalStops, 
    resource: "greenmile.minidashboard.undelivered" 
  });

  return parse(content);
}

export function getEconomyTruckData(data) {
  const serviceTimeCompliance = getParsedValue(
    data.actualServiceTimeSecs, 
    data.plannedServiceTimeSecs
  );
  const mileageCompliance = getParsedValue(
    data.actualDistance, 
    data.plannedDistance
  );
  const costPerformance = getParsedValue(
    data.actualCost, 
    data.plannedCost
  );
  const smartGeocodeCorrections = getSmartGeocodingValue(data);
  const timeWindowCompliance = getTimeWindowComplianceValue(data);
  const stopServiceCompliance = getStopServiceComplianceValue(data);

  return {
    serviceTimeCompliance,
    mileageCompliance,
    costPerformance,
    smartGeocodeCorrections,
    timeWindowCompliance,
    stopServiceCompliance
  };
}